import Button from 'skin/entry/cmp/button';
import styles from './style.module.css';
import { useContext } from 'react';
import DropCtx from 'skin/entry/cmp/drop/context';

export default function Address({ wait, list, value, setValue }) {
	const { setOpen } = useContext(DropCtx);
	const setAddress = (v) => {
		setOpen(false);
		setValue(v);
	};
	if (!list) return null;
	if (wait && wait !== 'typing') return <div className={styles.scroll}>
		<div className={styles.empty}>
			<span>Получение данных</span>
		</div>
	</div>
	if (!list?.length && wait !== 'typing') return <div className={styles.scroll}>
		<div className={styles.empty}>
			<span>По запросу "{value}"</span>
			<span>Ничего не найдено</span>
		</div>
	</div>;
	return <div className={styles.scroll}>
		{list.map(e => <Button key={e.data.fias_id} className={styles.item} mini type='link2' onClick={() => setAddress(e.unrestricted_value)}>
			{e.value}
		</Button>)}
	</div>
}